export default __webpack_public_path__ + "static/media/13-100.4818d9dc.jpg";